export default "__VITE_ASSET__32a8db6f__"